import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApiService } from '../api/api.service';
import { LoggerService } from '../shared/logger.service';
import { cookieHeaderName } from '../common/constants.lib';

export const casiXsrfInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  const apiService = inject(ApiService);
  // const cookieHeaderName = 'X-CSRF-TOKEN';
  // logger.debug('casiXsrfInterceptor:...: ');
  // return apiService.getCsrf()
  //   .pipe(
  //     switchMap((data: any) => {
  //       logger.debug(`csrf data: `, data);
  //       if (data && data._csrf) {
  //         let newReq = req.clone({ headers: req.headers.set(cookieHeaderName, data._csrf) });
  //         return next(newReq);
  //       }
  //       return next(req);
  //     }),
  //     catchError(errorData => {
  //       logger.error(`casiXsrfInterceptor:error:`, errorData);
  //       return next(req);
  //     })
  //   )
  // let csrfToken = apiService.csrfToken;
  let csrfToken = apiService.computedTokenCsrf();
  logger.debug('casiXsrfInterceptor:csrfToken: ', csrfToken);
  if ((csrfToken !== null && csrfToken !== 'not set') && !req.headers.has(cookieHeaderName)) {
    // logger.debug('casiXsrfInterceptor...adding header...');
    let newReq = req.clone({
      withCredentials: true,
      headers: req.headers.set(cookieHeaderName, csrfToken)
    });
    return next(newReq);
  } else {
    return next(req);

  }
};
